import { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux';
import { cardDetails, deleteCard, setDefaultCard } from '../../Redux';
import { toast } from 'react-toastify';
import jwt_decode from "jwt-decode";
import Footer from '../../Components/Footer'
import Switch from '@mui/material/Switch';
import Header from '../../Components/Header';
import GoBack from '../BackButton/GoBack';
import { useHistory } from 'react-router-dom';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import React from 'react';

function SaveCards(props: any) {
    const history = useHistory();
    const isLogged = useSelector((state: any) => state.customer.isLogged);
    const cardTokens = useSelector((state: any) => state.customer.cardDetails);
    const [value, setValue] = useState(0);
    let token = localStorage.getItem("userToken")
    
    let userData: any = token ? jwt_decode(token) : null
    const images: any = {
        'Mastercard' : '/mastercard-logo.png',
        'Visa' : '/visa-logo.png'
    }
    const lang = useCurrentLocale();

    useEffect(() => {
        window.scrollTo(0, 0);
        if (!isLogged) {
            toast.error(t("LOGIN_REQUIRED_SAVED_CARDS"))
            history.push(`/${lang}/menu`);
        } else {
            props.cardsList()
        }
    }, []);

    useEffect(() => {
        if (cardTokens && cardTokens.length > 0) {
            let index = cardTokens.findIndex((obj: any, index: any) => {
                return obj.is_default == 1
            });

            if (index !== -1) {
                const shiftedElement = cardTokens.splice(index, 1)[0];
                cardTokens.unshift(shiftedElement);
                setValue(value + 1)
            }
        }
    }, [cardTokens])

    const maskCardDigits = (number: any) => {
        const regex = /^\d{6}/;
        return number.replace(regex, 'xxxxxx');
    }      

    const setDefaultCard = async (token: any) => {
        props.setDefaultCard(token)
    }
    
    const label = { inputProps: { 'aria-label': 'switch demo' } };
    const { t } = useTranslation();

    return (
        <>
            <Header />
            <div className='container mt-120 profile-title'>
                <span className='d-flex align-items-center gap-10 mb-3 web-backbtn'>
                    <GoBack />
                    <div className='d-flex w-100 justify-content-between'>
                        <h2 className='mb-0'>{t("CARDS")}</h2> 
                    </div>
                </span>
                <div>
                    {
                        cardTokens && cardTokens.length > 0 ?
                        cardTokens.map((obj: any, index: any) => {
                            return (
                                <div className='save-address mb-2'>
                                    <div className='cards-container'>
                                        <div className='card-items'>
                                            <img src={images[obj.card_type]} alt={obj.card_type} className='payment-card-image' />
                                            <span>{maskCardDigits(obj.masked_card)}&nbsp;{obj.is_default == 1 ? "(Default)" : ""}</span>
                                        </div>
                                        <div className='card-items'>
                                            <span style={{ cursor: "pointer" }} onClick={() => props.deleteCard(obj.id)}><i className="ri-delete-bin-line"></i></span>
                                            <div>
                                                <Switch className='address-switch' {...label} color="error" 
                                                    onChange={() => {
                                                        setDefaultCard(obj.payment_token)
                                                    }} 
                                                    checked={obj.is_default == 1}
                                                    disabled={obj.is_default == 1 ? true : false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }) 
                        : 
                            <h2 className='text-center mt-4'>{t("NO_CARD_SAVED_YET")}</h2>
                    }
                </div>
            </div>
            <Footer />
        </>
    )
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        cardsList: function () {
            dispatch(cardDetails());
        },
        deleteCard: (token: any) => {
            dispatch(deleteCard(token))
        },
        setDefaultCard: (token_id: any) => {
            dispatch(setDefaultCard(token_id))
        },
    };
};

export default connect(null, mapDispatchToProps)(SaveCards)